import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Unknown/removed section type: null in 'live' (graceful drop), labelled placeholder in 'edit'. Never throws. */
import { t } from '@aquilixshop/i18n';
export function FallbackSection({ type, mode }) {
    if (mode === 'live')
        return null;
    return (_jsxs("div", { "data-aqx-fallback": "", style: {
            paddingBlock: 'var(--aqx-sp-4)',
            paddingInline: 'var(--aqx-sp-6)',
            border: '1px dashed var(--aqx-line)',
            borderRadius: 'var(--aqx-r-md)',
            color: 'var(--aqx-ink-3)',
            fontFamily: 'var(--aqx-font-sans)',
            fontSize: 'var(--aqx-text-sm)',
        }, children: [t(null, 'error.unknown_section'), ' ', _jsx("code", { style: { fontFamily: 'var(--aqx-font-mono)' }, children: type })] }));
}
//# sourceMappingURL=FallbackSection.js.map